<!--
 * @Description: 描述
 * @Author: D
 * @Date: 2024-03-14 14:10
 * @LastEditTime: 2024-03-27 15:12
 * @LastEditors: D
 * @FilePath: \admin\src\Layout\Header\menu.vue
-->
<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    @select="handleSelect"
  >
    <el-menu-item
      v-for="(item, index) in menuObj"
      :key="index"
      @click="handleClick2(item)"
    >
      {{ item.name }}
    </el-menu-item>
  </el-menu>
  <div class="left-box" v-if="flag">
    <menu-tree :menuList="leftMenu"></menu-tree>
  </div>
</template>

<script setup>
import MenuTree from "./MenuTree.vue";
import { ref } from "vue";
const activeIndex = ref("1");
const handleSelect = (key, keyPath) => {
  console.log(key, keyPath);
};

//所有菜单数据
let menuObj = [
  {
    path: "/home",
    name: "车辆管理",
    index: 1,
    children: null,
    meta: {
      name: "首页",
      isLink: false,
      isHide: false,
      isKeepAlive: false,
      isAffix: false,
      isIframe: false,
      icon: "el-icon-s-home",
    },
  },

  {
    path: "/home",
    name: "审核管理",
    children: [
      {
        path: "/dataAll/Authorize/Purpose",
        name: "1-1-2",
        children: null,
        meta: {
          name: "2222",
          isLink: false,
          isHide: false,
          isKeepAlive: false,
          isAffix: false,
          isIframe: false,
          icon: "el-icon-more-outline",
        },
      },
    ],
    index: 2,
    meta: {
      name: "首页",
      isLink: false,
      isHide: false,
      isKeepAlive: false,
      isAffix: false,
      isIframe: false,
      icon: "el-icon-s-home",
    },
  },
];

// 点击二级菜单展示左侧菜单
const handleClick2 = (item) => {
  console.log("😂👨🏾‍❤️‍👨🏼==>：", item);
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  width: 100%;
}

.el-menu--horizontal.el-menu {
  border-bottom: none;
}
</style>